import styled, { css, keyframes } from 'styled-components';
import { HEX, RGB } from '../../Styles/LegacyColors/index.js';
import { commonResets } from '../../Styles/Utils/commonResets.js';
import { phone, phoneMax } from '../../Styles/MediaQueries/mediaQueries.js';

// TO DO: Align and extract these to theme. (WP-254)
// TO DO: Extract styles from _commonStyles to packages/styles (WP-255)
const easeAnimation = css `
    transition: all 0.15s ease;
`;
const spin = keyframes `
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;
const Button = styled.button `
    ${commonResets}
    & *,
    &:before,
    &:after,
    & *:before,
    & *:after {
        ${commonResets}
    }

    display: inline-block;
    cursor: pointer;
    position: relative;
    background: none;

    &:before {
        ${easeAnimation}

        border: 3px solid ${HEX.lightGrey};
        border-top: 3px solid ${HEX.blue};
        border-radius: 50%;
        width: 30px;
        height: 30px;
        animation: ${spin} 2s linear infinite;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -15px 0 0 -15px;

        content: ' ';
        display: block;

        opacity: 0;
        visibility: hidden;
    }

    ${(props) => props.isLoading &&
    css `
            cursor: not-allowed;

            &:before {
                opacity: 1;
                visibility: visible;
            }
        `}

    ${(props) => props.centred &&
    css `
            width: 100%;
            display: block;
            text-align: center;
        `}

    ${(props) => props.fullWidth &&
    css `
            width: 100%;
        `}

    ${(props) => props.disabled &&
    css `
            opacity: 0.5;
            cursor: not-allowed;
        `}
`;
const Wrap = styled.div `
    ${easeAnimation}

    position: relative;
    font-size: 14px;
    line-height: 1.45;
    font-weight: 700;
    min-height: 45px;

    display: flex;
    align-items: center;
    text-transform: uppercase;
    border-radius: 100px;
    padding: 10px 20px;

    color: ${HEX.darkGrey};
    border: 2px solid ${HEX.darkGrey};
    background-color: transparent;

    ${ /* sc-selector */Button}:hover && {
        background-color: rgba(${RGB.darkGrey}, 0.1);
    }

    ${ /* sc-selector */Button}:active && {
        background-color: rgba(${RGB.darkGrey}, 0.15);
    }

    ${(props) => props.primary &&
    css `
            color: ${HEX.white};
            border-color: ${HEX.purple};
            background-color: ${HEX.purple};
            ${Button}:hover && {
                background-color: rgba(${RGB.purple}, 0.8);
            }

            ${Button}:active && {
                border-color: ${HEX.brightPurple};
                background-color: ${HEX.brightPurple};
            }
        `}

    ${(props) => props.primaryOutline &&
    css `
            color: ${HEX.purple};
            border: 2px solid ${HEX.purple};
            background-color: transparent;
            ${Button}:hover && {
                background-color: rgba(${RGB.purple}, 0.1);
            }

            ${Button}:active && {
                color: ${RGB.brightPurple};
                border-color: ${RGB.brightPurple};
                background-color: rgba(${RGB.purple}, 0.15);
            }
        `}

    ${(props) => props.small &&
    css `
            min-height: 30px;
            padding-top: 5px;
            padding-bottom: 5px;
            font-size: 12px;
        `}

    ${(props) => (props.arrow || props.arrowWhite) &&
    css `
            padding-right: 50px;
        `}

    ${(props) => props.arrow &&
    css `
            padding-right: 50px;
        `}

    ${(props) => props.white &&
    css `
            color: ${HEX.white};
            border: 2px solid ${HEX.white};
            background-color: transparent;

            ${Button}:hover && {
                background-color: rgba(${RGB.white}, 0.1);
            }
            ${Button}:active && {
                background-color: rgba(${RGB.white}, 0.15);
            }
        `}

    ${(props) => props.isLoading &&
    css `
            ${Button} && {
                opacity: 0.5;
            }
        `}

    ${(props) => props.centred &&
    css `
            ${Button} && {
                display: inline-block;
            }
        `}

    ${(props) => props.fullWidth &&
    css `
            ${Button} && {
                display: block;
            }
        `}

    @media ${phone} and ${phoneMax} {
        font-size: 12px;
    }
`;
const Arrow = styled.div `
    ${easeAnimation}

    display: none;
    width: 20px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 20px;

    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='11px' height='18px' viewBox='0 0 11 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EPage 1%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Final-' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Halo-Desktop' transform='translate(-570.000000, -6251.000000)' fill='%23333'%3E%3Cg id='Why-Grover' transform='translate(0.000000, 5824.000000)'%3E%3Cg id='CTA-arrow-right' transform='translate(359.000000, 424.000000)'%3E%3Cg id='text-CTA'%3E%3Cpolygon id='Page-1' points='212.414 3.0001 211 4.4141 218.293 11.7071 211 19.0001 212.414 20.4141 221.122 11.7071'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-size: auto auto;
    background-position: 50% 50%;
    background-repeat: no-repeat;

    transform: translate3d(0, 0, 0);

    ${ /* sc-selector */Button}:hover && {
        transform: translate3d(3px, 0, 0);
    }

    ${ /* sc-selector */Button}:active && {
        transform: translate3d(3px, 0, 0);
    }

    ${(props) => props.arrow &&
    css `
            display: block;
        `}

    ${(props) => props.arrowWhite &&
    css `
            background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='11px' height='18px' viewBox='0 0 11 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EPage 1%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Final-' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Halo-Desktop' transform='translate(-570.000000, -6251.000000)' fill='%23FFFFFF'%3E%3Cg id='Why-Grover' transform='translate(0.000000, 5824.000000)'%3E%3Cg id='CTA-arrow-right' transform='translate(359.000000, 424.000000)'%3E%3Cg id='text-CTA'%3E%3Cpolygon id='Page-1' points='212.414 3.0001 211 4.4141 218.293 11.7071 211 19.0001 212.414 20.4141 221.122 11.7071'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
            display: block;
        `}
`;

export { Arrow, Button, Wrap };
